import React, { PureComponent } from 'react';
import Icon from 'react-icon-base';
import styled from 'styled-components';

const RadioOn = props => {
  return (
    <Icon viewBox="0 0 512 512" color="#5bb9ef" {...props}>
      <path d="M256 48C141.6 48 48 141.6 48 256s93.6 208 208 208 208-93.6 208-208S370.4 48 256 48zm-42.7 318.9L106.7 260.3l29.9-29.9 76.8 76.8 162.1-162.1 29.9 29.9-192.1 191.9z" />
    </Icon>
  );
};

const RadioOff = props => {
  return (
    <Icon viewBox="0 0 512 512" {...props}>
      <path d="M256 48C141.601 48 48 141.601 48 256s93.601 208 208 208 208-93.601 208-208S370.399 48 256 48zm0 374.399c-91.518 0-166.399-74.882-166.399-166.399S164.482 89.6 256 89.6 422.4 164.482 422.4 256 347.518 422.399 256 422.399z" />
    </Icon>
  );
};

const Label = styled.label`
  display: flex;
`;

const Input = styled.input`
  opacity: 0;
  position: absolute;
`;

const Title = styled.div`
  margin-top: 4px;
  margin-left: 8px;
  font-family: HelveticaNeueLTPro-Roman;
  font-size: 0.76em;
  color: black;
`;

class Radio extends PureComponent {
  renderIcon = () => {
    const { selected } = this.props;
    return selected ? <RadioOn /> : <RadioOff />;
  };
  render() {
    const { title, category, selected, onClick } = this.props;
    return (
      <Label>
        <Input
          readOnly
          type="radio"
          checked={selected ? 'checked' : ''}
          aria-selected={selected ? 'true' : 'false'}
          name={category}
          onClick={onClick}
        />
        <span>{this.renderIcon()}</span>
        <Title>{title}</Title>
      </Label>
    );
  }
}

export default Radio;



// WEBPACK FOOTER //
// ./src/components/accords/Radio/Radio.js